import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRowingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.5 0A3.5 3.5 0 000 3.5v.987a3.5 3.5 0 00.818 2.248l4.678 5.583A7.5 7.5 0 0011.244 15H18.7l3.393 4.318-7.496 9.54-1.426-1.12-1.854 2.358 1.427 1.121-11.42 14.536 2.358 1.853 11.421-14.535 1.427 1.121 1.854-2.359-1.427-1.121L24 21.746l7.045 8.966-1.428 1.121 1.854 2.36 1.427-1.122 11.42 14.535 2.36-1.853-11.421-14.536 1.427-1.12-1.854-2.36-1.426 1.122-7.496-9.54L29.3 15h7.455a7.5 7.5 0 005.748-2.682l4.678-5.583A3.5 3.5 0 0048 4.487V3.5A3.5 3.5 0 0044.5 0h-5.528a3.5 3.5 0 00-2.752 1.338l-8.828 11.235-.005.007L24 16.89l-3.387-4.31-.005-.007L11.78 1.338A3.5 3.5 0 009.028 0zM3 3.5a.5.5 0 01.5-.5h5.528a.5.5 0 01.393.191L16.342 12h-5.098a4.5 4.5 0 01-3.448-1.61l-4.68-5.582A.5.5 0 013 4.488zm42 0v.987a.5.5 0 01-.117.321l-4.679 5.583A4.5 4.5 0 0136.757 12L31.658 12l6.92-8.809A.5.5 0 0138.973 3H44.5a.5.5 0 01.5.5z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRowingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRowingNormalLarge;
